export var EField;
(function (EField) {
    EField["Country"] = "country";
    EField["Street"] = "street";
    EField["Number"] = "number";
    EField["Box"] = "box";
    EField["Zip"] = "zip";
    EField["City"] = "city";
    EField["State"] = "state";
})(EField || (EField = {}));
